export default __webpack_public_path__ + "static/media/hair-cutting.de518445.png";